import { WEI, } from "@bracket/blocksmith";
import * as G from "@globals";
import type { LoadedVault, } from "@types";
import type { StoreKey, StoreNames, } from "idb";
import { getIDB, } from "./IDB";
import type { PlatformDBSchema, } from "./types";



export declare type HydrateResult<T extends object> = {
	fetched: true;
	props: T;
} | {
	fetched: false;
	error?: Error | null;
	props: null;
}

declare type HFN<S extends keyof PlatformDBSchema> = ( props: PlatformDBSchema[S]["value"], ) => PlatformDBSchema[S]["value"] | Promise<PlatformDBSchema[S]["value"]>;

export const hydrate = async <S extends keyof PlatformDBSchema>( name: S, fn?: HFN<S> ): Promise<HydrateResult<PlatformDBSchema[S]["value"]>> => {

	const { search, } = globalThis.location;
	if(search.toLowerCase().includes("cache=false")) {
		return { fetched: false, props: null, };
	}

	if(!search.includes("hydrate=true")) {
		if(!["swap", "platform", "vaults", "bars_leaderboard", "bars_points", "wallet_points",].includes(name as string)) {
			return { fetched: false, props: null, };
		}
	}

	try {

		const db = await getIDB();
		const txn = db.transaction(name as StoreNames<PlatformDBSchema>, "readonly");
		const store = txn.objectStore(name as StoreNames<PlatformDBSchema>);
		const { address, } = G.wallet.getBracketWallet();
		if(address) {
			// TODO: fix this later
			// biome-ignore lint/suspicious/noExplicitAny: <fix later>
			const stored = await store.get(address as StoreKey<any, any>);
			if(!stored) {
				return { fetched: false, props: null, error: null, };
			}
			//TODO: type this
			// @ts-expect-error - fix this later.
			let props = JSON.parse(stored.value);

			if(name === "platform") {
				props.brkt_tvl = props.brkt_tvl ? {
					usd: props.brkt_tvl.usd,
					asset: WEI.fromJSON(props.brkt_tvl.asset),
				} : null;
			}

			if(name === "vaults") {

				props.available = props.available.map((v:LoadedVault) => {
					return {
						...v,
						// TODO: fix this later
						// biome-ignore lint/suspicious/noExplicitAny: <fix later>
						wrapperBalance: v.wrapperBalance ? WEI.fromJSON(v.wrapperBalance as any) : null,
						// biome-ignore lint/suspicious/noExplicitAny: <fix later>
						vaultBalance: v.vaultBalance ? WEI.fromJSON(v.vaultBalance as any) : null,
						morpho_data: v.morpho_data ? {
							lltv: WEI.fromJSON(v.morpho_data.lltv),
							leverage: WEI.fromJSON(v.morpho_data.leverage),
							leveragedYield: WEI.fromJSON(v.morpho_data.leveragedYield),
							borrowYield: WEI.fromJSON(v.morpho_data.borrowYield),
						} : null,
					}
				});

				props.active = props.active ? {
					...props.active,
					wrapperBalance: props.active.wrapperBalance ? WEI.fromJSON(props.active.wrapperBalance) : null,
					vaultBalance: props.active.vaultBalance ? WEI.fromJSON(props.active.vaultBalance) : null,
					morpho_data: props.active.morpho_data ? {
						lltv: WEI.fromJSON(props.active.morpho_data.lltv),
						leverage: WEI.fromJSON(props.active.morpho_data.leverage),
						leveragedYield: WEI.fromJSON(props.active.morpho_data.leveragedYield),
						borrowYield: WEI.fromJSON(props.active.morpho_data.borrowYield),
					} : null,
				} : null;
			}

			if(props) {
				if(fn) {
					props = await fn(props);
				}
				return { fetched: true, props, };
			}
			return { fetched: false, props: null, error: null, };
		}
		return { fetched: false, props: null, error: null, };
	}
	catch(err) {

		console.error(`ERROR HYDRATING STORE "${name}"`, err);
		return { fetched: false, error: err as Error, props: null, };
	}

}
